import { defineComponent, ref, onMounted, nextTick } from 'vue'
import MapPage from '@/organizations/_default/map'
import FilterInfo from '@/organizations/mitsubishi-food/default/components/FilterInfo.vue'
import ProductModal from '@/organizations/mitsubishi-food/default/components/ProductModal.vue'
import { Filters } from '@/services/Filters.ts'
import { parseMessage } from '@/utils/format.ts'
import uikit from 'uikit'

export default defineComponent({
  extends: MapPage,
  components: {
    FilterInfo,
    ProductModal
  },
  setup(props, context) {
    const page = MapPage.setup(props, context)

    const selectedProduct = ref({})
    const productModalRef = ref(null)

    const persistentMessage = ref({
      enabled: storelocator.map?.persistent_message?.enabled || false,
      message: parseMessage(storelocator.map?.persistent_message?.message || ''),
      title: storelocator.messages.modal_persistent_message_title || '',
    })

    onMounted(() => {
      nextTick(() => {
        // filter_storeの配下全体にあるfilter-infoを非表示にする
        // 商品フィルター以外には商品ダイアログ不要のため
        const filterStore = document.querySelector('[data-id="search-condition-group-filter_store"]')
        if (filterStore) {
          const filterInfos = filterStore.querySelectorAll('.filter-info')
          filterInfos.forEach(filterInfo => {
            filterInfo.style.display = 'none'
          })
        }

        const elements = document.querySelectorAll('.filter-info')

        elements.forEach(element => {
          const filterId = element.dataset.filterId

          element.addEventListener('click', () => {
            if (!filterId) {
              return
            }

            const filter = Filters.findById(Filters.TYPE_SEARCH_CONDITIONS, filterId)
            if (!filter) {
              return
            }

            /**
             * infoアイコンに対応するフィルターを保持
             *
             * 商品モーダルに以下のプロパティを使用
             * filter.name: 商品名(既存)
             * filter.image.url: 商品画像のURL(既存)
             * filter.extra_fields.product_description: 商品説明(追加)
             * filter.extra_fields.product_url: 商品詳細ページのURL(追加)
             */
            selectedProduct.value = filter
            productModalRef.value?.open()

            storelocator.analytics.client?.send('SelectProductInfo', {
              ProductId: filter.id,
              ProductName: filter.name,
            })
          })
        })
      })

      // 初期表示警告メッセージを表示
      if (persistentMessage.value.enabled && persistentMessage.value.message) {
        uikit.modal('#notation-modal').show()
      }
    })

    return {
      ...page,
      selectedProduct,
      productModalRef,
      persistentMessage
    }
  }
})
